var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiInstance } from '@/api/index';
import { getCurrentLanguage } from '@/utils/lang';
const SpellsContext = createContext({ spells: [], loading: false });
export const SpellsProvider = ({ children }) => {
    const [loadedSpells, setSpells] = useState([]);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const api = useApiInstance();
    const fetchSpells = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        yield api.spellsApiInstance
            .list({ lang: getCurrentLanguage() })
            .then((response) => {
            setSpells(response);
        })
            .catch((error) => {
            console.error(error);
        })
            .finally(() => {
            setLoading(false);
        });
    }), [api.spellsApiInstance]);
    useEffect(() => {
        fetchSpells();
    }, [fetchSpells, i18n.language]);
    const spells = useMemo(() => loadedSpells, [loadedSpells]);
    return _jsx(SpellsContext.Provider, { value: { spells, loading }, children: children });
};
export const useSpells = () => useContext(SpellsContext);
